export default class SogepromUTM {

	static init() {
		const params = new URLSearchParams(window.location.search);
		let utm_source = params.get("utm_source");
		let utm_content = params.get("utm_content");
		let utm_medium = params.get("utm_medium");
		let utm_campaign = params.get("utm_campaign");
		let utm_term = params.get("utm_term");

		// Vérification de la provenance SEO si pas d'UTM
		if (!utm_source) {
			if (document.referrer) {
				if (document.referrer.includes("google.com")) {
					utm_source = "google";
					utm_medium = "seo";
					utm_content = "";
					utm_campaign = "";
					utm_term = "";
				} else if (document.referrer.includes("bing")) {
					utm_source = "bing";
					utm_medium = "seo";
					utm_content = "";
					utm_campaign = "";
					utm_term = "";
				} else if (document.referrer.includes("yahoo")) {
					utm_source = "yahoo";
					utm_medium = "seo";
					utm_content = "";
					utm_campaign = "";
					utm_term = "";
				}
			}
		}

		// UTM par défaut si pas d'utm
		if (!SogepromUTM.getUTMs().utm_source) {
			const newUTM = {
				utm_source: "saisie-direct",
				utm_medium: "saisie-direct",
				utm_content: "",
				utm_campaign: "",
				utm_term: "",
			};
			localStorage.setItem("sogeprom.utm", JSON.stringify(newUTM));
		}


		if (utm_source || utm_content || utm_medium || utm_campaign || utm_term) {
			const newUTM = {
				utm_source,
				utm_content,
				utm_medium,
				utm_campaign,
				utm_term,
			};

			localStorage.setItem("sogeprom.utm", JSON.stringify(newUTM));
		}

		const utm = SogepromUTM.getUTMs();
		let form = document.querySelector('.sidebar');
		let utmSource = form.querySelector('input[name="input_15"]');
		let utmMedium = form.querySelector('input[name="input_16"]');
		let utmCampaign = form.querySelector('input[name="input_17"]');
		let utmContent = form.querySelector('input[name="input_18"]');
		let utmTerm = form.querySelector('input[name="input_19"]');

		utmSource.value = utm.utm_source || "";
		utmMedium.value = utm.utm_medium || "";
		utmCampaign.value = utm.utm_campaign || "";
		utmContent.value = utm.utm_content || "";
		utmTerm.value = utm.utm_term || "";
	}

	static getUTMs() {
		const currentUTM = localStorage.getItem("sogeprom.utm");
		if (currentUTM) {
			return JSON.parse(currentUTM);
		} else {
			return {};
		}
	}
}
